import * as RxTooltip from '@radix-ui/react-tooltip';
import { ReactNode } from 'react';
import { type VariantProps, tv } from 'tailwind-variants';

import Text from '../base/Text';
import './Tooltip.css';

const tooltip = tv({
  base: 'rx-tooltip flex max-w-[90vw] items-center rounded-lg px-2 py-1',
  variants: {
    color: {
      default: 'bg-gray-90 dark:border-gray-75 text-white dark:border-2',
      transparent: 'text-gray-90 bg-transparent', // Deprecated
    },
    inModal: {
      true: 'z-10000 relative',
      false: '',
    },
  },
  defaultVariants: {
    color: 'default',
  },
});

export default function Tooltip({
  children,
  text,
  side = 'top',
  color,
  disabled,
  inModal,
}: {
  children: ReactNode;
  text: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  color?: VariantProps<typeof tooltip>['color'];
  disabled?: boolean;
  inModal?: boolean;
}) {
  if (disabled) {
    return <>{children}</>;
  }

  return (
    <RxTooltip.Provider delayDuration={300}>
      <RxTooltip.Root>
        <RxTooltip.Trigger onFocus={(e) => e.preventDefault()} asChild>
          {children}
        </RxTooltip.Trigger>
        <RxTooltip.Portal>
          <RxTooltip.Content
            className={tooltip({ color, inModal })}
            sideOffset={color !== 'transparent' ? 8 : 4}
            side={side}
          >
            <Text variant="studio/body/medium/sm">{text}</Text>
            {/* {color !== 'transparent' && (
              <RxTooltip.Arrow className="fill-gray-90" />
            )} */}
          </RxTooltip.Content>
        </RxTooltip.Portal>
      </RxTooltip.Root>
    </RxTooltip.Provider>
  );
}
